import { refreshFetch, statusCodeHelperResponse } from './axios';
import { logger } from 'utils';

export interface INewApplicationPayload {
  tenor: number;
  principal: number;
  fingerprint_request_id?: string;
  fingerprint_visitor_id?: string;
}

export const confirmationCodeApplication = async (data?: { confirmedPrincipal?: number; bankAccountUuid?: string }) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/confirm';
  const response = await axios({
    method: 'post',
    url: endpoint,
    data,
  });
  logger('confirmationCodeApplication response', response);
  return await statusCodeHelperResponse(response);
};

export const getActiveApplication = async (signal?: AbortSignal) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/active';

  const response = await axios({
    method: 'get',
    url: endpoint,
    signal,
  });

  logger('getActiveApplication response', response);

  return await statusCodeHelperResponse(response);
};

export const createApplication = async (payload: INewApplicationPayload) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/create';

  const response = await axios({
    method: 'post',
    url: endpoint,
    data: payload,
  });
  logger('createApplication response', response);

  return await statusCodeHelperResponse(response);
};

export const getTotalAmount = async (payload: any) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/amounts';

  const response = await axios({
    method: 'post',
    url: endpoint,
    data: payload,
  });
  logger('getTotalAmount response', response);

  return await statusCodeHelperResponse(response);
};

export const getTotalAmountCounterOffer = async (payload: any) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/amounts';

  const response = await axios({
    method: 'patch',
    url: endpoint,
    data: payload,
  });
  logger('getTotalAmountCounterOffer response', response);

  return await statusCodeHelperResponse(response);
};

export const getPendingApplication = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/pending';

  const response = await axios({
    method: 'get',
    url: endpoint,
  });
  logger('getPendingApplication response', response);

  return await statusCodeHelperResponse(response);
};

export const postPendingApplication = async (payload: any) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/pending';

  const response = await axios({
    method: 'patch',
    url: endpoint,
    data: payload,
  });
  logger('postPendingApplication response', response);

  return await statusCodeHelperResponse(response);
};

export const sendFirstViewTimestamp = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/view';

  const response = await axios({
    method: 'post',
    url: endpoint,
  });
  logger('sendFirstViewTimestamp response', response);

  return await statusCodeHelperResponse(response);
};

export const sendRejectedApplicationView = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/active/reject/view';

  const response = await axios({
    method: 'post',
    url: endpoint,
  });
  logger('sendRejectedApplicationView response', response);

  return await statusCodeHelperResponse(response);
};
